"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Details = _interopRequireDefault(require("./Details"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SyncSummary = function SyncSummary(_ref) {
  var summary = _ref.summary,
    header = _ref.header;
  var typeMap = {
    site: 'School',
    siteAdmin: 'School Admin',
    "class": 'Class',
    instructor: 'Teacher',
    learner: 'Student'
  };
  function typeToLabel(type) {
    return typeMap[type];
  }
  function pluralize(label) {
    if (label === 'Class') {
      return 'Classes';
    }
    return label + 's';
  }
  var byType = summary.byType ? summary.byType : summary['metadata.byType'];
  var bySite = summary.bySite ? summary.bySite : summary['metadata.bySite'];
  var byGrade = summary.byGrade ? summary.byGrade : summary['metadata.byGrade'];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert alert-info"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, header), summary.errors && summary.errors.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert alert-danger"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-inline"
  }, summary.errors.map(function (errorSummary, j) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: j
    }, errorSummary.message);
  }))), summary.warnings && summary.warnings.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert alert-warning"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-inline"
  }, summary.warnings.map(function (warningSummary, j) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: j
    }, warningSummary.message);
  }))), byType && byType.length > 0 && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-unstyled"
  }, byType.sort(function (a, b) {
    return a.name < b.name ? -1 : 1;
  }).filter(function (details, key) {
    return details.count > 0;
  }).map(function (typeSummary, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: 'type' + i
    }, /*#__PURE__*/_react["default"].createElement("b", null, pluralize(typeToLabel(typeSummary.type)), ":"), ' ', /*#__PURE__*/_react["default"].createElement(_Details["default"], {
      countObject: typeSummary.summary
    }), typeSummary.warnings && typeSummary.warnings.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-warning"
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      className: "list-inline"
    }, typeSummary.warnings.map(function (warningSummary, j) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: j
      }, warningSummary.count + ' ' + warningSummary.message, warningSummary.examples && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("br", null), "Examples: ", warningSummary.examples.join(', ')));
    }))), typeSummary.errors && typeSummary.errors.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-danger"
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      className: "list-inline"
    }, typeSummary.errors.map(function (errorSummary, j) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: j
      }, errorSummary.count + ' ' + errorSummary.message, errorSummary.examples && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("br", null), "Examples: ", errorSummary.examples.join(', ')));
    }))));
  }))), bySite && bySite.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].syncSummaryTop
  }, /*#__PURE__*/_react["default"].createElement("h4", null, "Summary By School"), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-unstyled"
  }, bySite.sort(function (a, b) {
    return a.name < b.name ? -1 : 1;
  }).map(function (siteSummary, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: 'type' + i
    }, /*#__PURE__*/_react["default"].createElement("b", null, siteSummary.name, ": "), " ", siteSummary.status, /*#__PURE__*/_react["default"].createElement("ul", {
      className: 'list-unstyled ' + _style["default"].listIndent
    }, siteSummary.byType.sort(function (a, b) {
      return a.name < b.name;
    }).map(function (typeSummary, j) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: 'type' + j
      }, /*#__PURE__*/_react["default"].createElement("b", null, pluralize(typeToLabel(typeSummary.type)), ":"), ' ', typeSummary.count > 0 && /*#__PURE__*/_react["default"].createElement(_Details["default"], {
        countObject: typeSummary.summary
      }), typeSummary.warnings && typeSummary.warnings.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-warning"
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "list-inline"
      }, typeSummary.warnings.map(function (warningSummary, k) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: k
        }, warningSummary.count + ' ' + warningSummary.message, warningSummary.examples && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("br", null), "Examples:", ' ', warningSummary.examples.join(', ')));
      }))), typeSummary.errors && typeSummary.errors.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-danger"
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "list-inline"
      }, typeSummary.errors.map(function (errorSummary, k) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: k
        }, errorSummary.count + ' ' + errorSummary.message, errorSummary.examples && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("br", null), "Examples:", ' ', errorSummary.examples.join(', ')));
      }))));
    })), /*#__PURE__*/_react["default"].createElement("br", null));
  }))), byGrade && byGrade.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].syncSummaryTop
  }, /*#__PURE__*/_react["default"].createElement("h4", null, "Summary By Grade"), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-unstyled"
  }, byGrade.sort(function (a, b) {
    if (Number.isNaN(parseInt(a.name, 10)) && Number.isNaN(parseInt(b.name, 10))) {
      return a.name < b.name ? 1 : -1;
    }
    if (!Number.isNaN(parseInt(a.name, 10)) && Number.isNaN(parseInt(b.name, 10))) {
      return 1;
    }
    if (Number.isNaN(parseInt(a.name, 10)) && !Number.isNaN(parseInt(b.name, 10))) {
      return -1;
    }
    return parseInt(a.name, 10) < parseInt(b.name, 10) ? -1 : 1;
  }).map(function (gradeSummary, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: 'type' + i
    }, /*#__PURE__*/_react["default"].createElement("b", null, gradeSummary.name, ":"), " ", /*#__PURE__*/_react["default"].createElement(_Details["default"], {
      countObject: gradeSummary.summary
    }), /*#__PURE__*/_react["default"].createElement("br", null));
  }))));
};
SyncSummary.propTypes = {
  summary: _propTypes["default"].object.isRequired,
  header: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string])
};
SyncSummary.defaultProps = {
  header: 'Sync summary'
};
var _default = exports["default"] = SyncSummary;